// Desktop notifications
export const requestNotificationPermission = async () => {
  if ('Notification' in window) {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
  return false;
};

export const showNotification = (title, options = {}) => {
  if ('Notification' in window && Notification.permission === 'granted') {
    return new Notification(title, {
      icon: '/logo192.png',
      badge: '/logo192.png',
      ...options
    });
  }
};

export const showIncidentNotification = (incident) => {
  const severityEmoji = {
    low: '🟢',
    medium: '🟡',
    high: '🟠',
    critical: '🔴'
  };

  showNotification(
    `${severityEmoji[incident.severity]} ${incident.incident_type}`,
    {
      body: incident.description,
      tag: `incident-${incident.id}`,
      requireInteraction: incident.severity === 'critical',
      silent: incident.severity === 'low'
    }
  );
};








